import React from 'react';
import Setting from "../../../components/pages/grid/Setting/Setting";

const SettingGridPage = () => {
    return <Setting />
};

export default SettingGridPage;